// eslint-disable-next-line deprecation/deprecation
export { DataGridBody } from './DataGridBody';
// eslint-disable-next-line deprecation/deprecation
export { DataGrid } from './DataGrid';
// eslint-disable-next-line deprecation/deprecation
export { DataGridRow } from './DataGridRow';

export { DataGridCell, DataGridHeader, DataGridHeaderCell, DataGridSelectionCell } from '@fluentui/react-table';

export type {
  DataGridCellProps,
  DataGridHeaderCellProps,
  DataGridHeaderProps,
  DataGridSelectionCellProps,
  DataGridRowProps,
  DataGridProps,
} from '@fluentui/react-table';

export type { DataGridBodyProps, RowRenderer } from './DataGridBody';
